var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.userid)+" "),_c('button',{staticClass:"btn",on:{"click":function($event){$event.stopPropagation();return _vm.details.apply(null, arguments)}}},[_vm._v("点击")])])
}
var staticRenderFns = []

export { render, staticRenderFns }